/**
 * mse-match-column-heights.js
 *
 * DEAKTIVIERT: Die per JS injizierte Stretch-CSS (height:100% / padding:0
 * !important auf .product__media.media) hat dazu geführt, dass Produktbilder
 * mit gerenderter Höhe 0px unsichtbar wurden (media-gallery ist als Custom
 * Element standardmäßig display:inline, daher griff das per JS gesetzte
 * min-height nicht und die height:100%-Kette darunter kollabierte).
 * Bis das Höhen-Sync-Feature sauber neu gebaut ist, bleibt es deaktiviert.
 */
(function () {
  'use strict';
})();
